"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var styled_system_1 = require("styled-system");
var Img = styled_components_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tmax-width: 100%;\n\theight: auto;\n\t", ";\n\t", ";\n"], ["\n\tdisplay: block;\n\tmax-width: 100%;\n\theight: auto;\n\t", ";\n\t", ";\n"])), styled_system_1.space, styled_system_1.width);
Img.displayName = 'Img';
exports.default = Img;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/Img.js
// module id = 786
// module chunks = 2